<mat-dialog-content>

  <fieldset class="group">
    <legend id="theme-config">Temas</legend>
<!--    <mat-card-header>-->
<!--      <mat-card-title>Temas</mat-card-title>-->
<!--    </mat-card-header>-->
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Predefinidos
          </mat-panel-title>
          <mat-panel-description>
            <mat-icon color="primary" *ngIf="form.value.themeName != CUSTOM_THEME_TOKEN">star</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div style="margin: 4px">
          <mat-chip-listbox [selectable]="true">
            <mat-chip-option *ngFor="let tema of themes"
                      class="theme-chips"
                      (click)="themeSelectionChange(tema)"
                      [selected]="form.get('themeName').value == tema.themeName">
              <mat-chip-avatar style="width: 12px; height: 12px" [style.backgroundColor]="tema.mainColors.primaryColor"></mat-chip-avatar>
              {{tema.themeName}}
            </mat-chip-option>
          </mat-chip-listbox>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel >
        <mat-expansion-panel-header>
          <mat-panel-title>
            Personalizados
          </mat-panel-title>
          <mat-panel-description>
            <mat-icon color="primary" *ngIf="form.value.themeName == CUSTOM_THEME_TOKEN">star</mat-icon>
          </mat-panel-description></mat-expansion-panel-header>
        <mat-slide-toggle [formControl]="harmony">Harmony</mat-slide-toggle>
        <div class="palettes">
          <div>
            <h3>
              Primary
            </h3>
            <app-sub-palette-picker [form]="form.get('mainColors').get('primaryColor')"></app-sub-palette-picker>
          </div>
          <div>
            <h3>
              Accent
            </h3>
            <app-sub-palette-picker [form]="form.get('mainColors').get('accentColor')"></app-sub-palette-picker>
          </div>
          <div>
            <h3>
              Side Header
            </h3>
            <app-sub-palette-picker [disabled]="this.harmony.value" [form]="form.get('components').get('navbarPrimary').get('backgroundColor')"></app-sub-palette-picker>
          </div>
          <div>
            <h3>
              Navigation
            </h3>
            <app-sub-palette-picker [disabled]="this.harmony.value" [form]="form.get('components').get('navbarSecondary').get('backgroundColor')"></app-sub-palette-picker>
          </div>
          <div>
            <h3>
              Toolbar
            </h3>
            <app-sub-palette-picker [disabled]="this.harmony.value" [form]="form.get('components').get('toolbar').get('backgroundColor')"></app-sub-palette-picker>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </fieldset>
<!--  <mat-divider></mat-divider>-->
  <fieldset>
    <legend>Fondo</legend>
    <mat-chip-listbox style="margin: 8px">
      <mat-chip-option [selected]="!form.value.darkTheme" (click)="userChangedForm({darkTheme: false})">
        Light
        <mat-icon matChipTrailingIcon>light_mode</mat-icon>
      </mat-chip-option>
      <mat-chip-option [selected]="form.value.darkTheme" (click)="userChangedForm({darkTheme: true})">
        Dark
        <mat-icon matChipTrailingIcon>dark_mode</mat-icon>
      </mat-chip-option>
    </mat-chip-listbox>
  </fieldset>

<!--  <mat-divider></mat-divider>-->
<!--  <mat-divider></mat-divider>-->
  <fieldset class="images" [formGroup]="form">
    <legend>Imágenes</legend>
    <div class="image-field" formGroupName="images">
      <mat-label>Fondo página de error</mat-label>
      <app-simple-file-uploader-input-component formControlName="errorBackground"></app-simple-file-uploader-input-component>
    </div>


    <div class="image-field" formGroupName="images">
      <mat-label>Ícono de menú</mat-label>
      <app-simple-file-uploader-input-component
              imageBackgroundColor="var(--theme-navbar-primary-background-color)"
              formControlName="menuLogo"></app-simple-file-uploader-input-component>
    </div>

  </fieldset>

<!--  <mat-divider></mat-divider>-->
<!--  <mat-divider></mat-divider>-->


  <ng-container [formGroup]="form">
    <fieldset formGroupName="lddModules">
      <legend>Portal de Denuncias</legend>

      <fieldset *ngFor="let module of MODULES" [formGroupName]="module" class="static">
        <legend>{{'LDD_MODULES.'+module | translate}}</legend>
        <app-simple-file-uploader-input-component width="90%" height="200"  class="background" formControlName="backgroundImage"></app-simple-file-uploader-input-component>
        <app-ldd-module-color-picker *ngIf="!hideText.checked" formControlName="backgroundColor" class="text-background" placeholder="{{'LDD_MODULES.'+module | translate}}"></app-ldd-module-color-picker>
        <mat-checkbox formControlName="hideText" #hideText>Ocultar Texto</mat-checkbox>
      </fieldset>

    </fieldset>
  </ng-container>

  <fieldset [formGroup]="form">
    <legend>Footer</legend>
    <!-- <quill-editor formControlName="footerText" #quill (onSelectionChanged)="onChangeQuillSelection($event)">
    </quill-editor> -->
    <div #editor></div>
  </fieldset>

</mat-dialog-content>



<!--<mat-divider></mat-divider>-->
<div matDialogActions class="buttons">

  <button mat-raised-button
          [disabled]="!form.dirty"
          (click)="persist()" *ngIf="savePaletteBtn">Guardar</button>
  <button mat-raised-button
          [disabled]="!form.dirty"
          (click)="cancel()">Cancelar</button>
</div>
